import { PutImagesApi } from "@/features/accounts/ocr/services/put-images-api";
import { PutImagesRequestModel } from "@/features/accounts/ocr/services/put-images-model";

/// OCR読み取り画像キャンセル処理
export class PutImagesService {
  private putImagesApi = new PutImagesApi();

  /**
   * OCR読み取り画像キャンセルAPI実行
   */
  public async putImages(param: PutImagesRequestModel) {
    return await this.putImagesApi.putImages(param);
  }
}
